import { withStyles } from "$components/mui-styles";
import {
  type AccordionProps,
  Accordion as MUIAccordion,
} from "@material-ui/core";
import React, { useContext } from "react";
import { CardContext } from "./context";

const Accordion = withStyles({
  root: {
    "&.Mui-expanded": {
      margin: 0,
    },
    // A disabled accordion is how the card renders a non-toggleable (locked
    // open/closed) section; keep it visually identical to an enabled one.
    "&.Mui-disabled": {
      backgroundColor: "transparent",
    },
  },
})((props: AccordionProps) => <MUIAccordion elevation={0} {...props} />);

export interface CardBodyProps {
  children: React.ReactNode;
}

const CardBody = ({ children }: CardBodyProps) => {
  const { expandable, defaultExpanded, expanded, disabled, hideExpandIcon } =
    useContext(CardContext);

  if (expandable) {
    return (
      <Accordion
        defaultExpanded={defaultExpanded}
        expanded={expanded}
        disabled={disabled || hideExpandIcon}
        TransitionProps={{ unmountOnExit: true }}
      >
        {children as any}
      </Accordion>
    );
  }

  return <>{children}</>;
};

export default CardBody;
